import { ReferenceItem } from '../../../../../../types/types';

type GetTypeToSelectMatchOptions = {
  typedText: string;
  data: any[];
  idItem: string;
  labelItem: string;
  selectedLabels: string[];
  formatLabel: (value: string) => string;
};

type TypeToSelectMatch = {
  // The single unselected option whose label equals the typed text; null when none or more than one.
  exactMatch: ReferenceItem | null;
  // True when another unselected option's label continues the typed text — the user may still be typing.
  hasLongerOption: boolean;
};

// Case-insensitive type-to-select lookup over the loaded options, ignoring already selected chips.
export const getTypeToSelectMatch = ({
  typedText,
  data,
  idItem,
  labelItem,
  selectedLabels,
  formatLabel,
}: GetTypeToSelectMatchOptions): TypeToSelectMatch => {
  const typed = typedText.toLowerCase();
  if (typed === '') {
    return { exactMatch: null, hasLongerOption: false };
  }
  // String() guards labels that reached the chips unformatted (e.g. numeric label columns).
  const selected = new Set(
    selectedLabels.map((label) => String(label).toLowerCase())
  );
  let exactMatch: ReferenceItem | null = null;
  let exactMatchCount = 0;
  let hasLongerOption = false;

  data.forEach((item) => {
    const label = formatLabel(String(item[labelItem]));
    const labelLower = label.toLowerCase();

    if (selected.has(labelLower)) return;

    if (labelLower === typed) {
      exactMatchCount += 1;
      exactMatch = { value: item[idItem].toString(), label };
      return;
    }

    if (labelLower.startsWith(typed)) {
      hasLongerOption = true;
    }
  });
  // Duplicate labels cannot be auto-picked — only a click disambiguates them.
  return {
    exactMatch: exactMatchCount === 1 ? exactMatch : null,
    hasLongerOption,
  };
};
